<mat-checkbox (change)="fnTrainingMode($event.checked)" checked="">{{ 'status.txtTrainingMode' | translate }}</mat-checkbox><br/>
<span class="form-text-features">[{{ 'playerForm.txtInfoTrainingMode' | translate }}]</span> 
